import React, { useState, useEffect } from "react"
import Typography from "@mui/material/Typography"
import { Button, Container, Box, Checkbox, Stack, TextField, FormGroup, FormControlLabel } from '@mui/material'
import { useCuestionario } from "../hooks/useCuestionario.js"
import { useNavigate } from "react-router-dom"
import { useUser } from "../hooks/useUser"
import { useCrearPerfilEmpresarial } from "../hooks/useCrearPerfilEmpresarial"
import { useMunicipios } from "../hooks/useMunicipios"
import { useTranslation } from 'react-i18next'
import { Titulo } from "../components/commons/Titulo.jsx"
import { AutocompleteSearchRequired } from "../components/commons/AutocompleteSearchRequired.jsx"
import { useTools } from "../hooks/useTools.jsx"
import { ErrorMessage } from '../components/commons/ErrorMessage.jsx';
import { useForm } from "react-hook-form"
import { TextFieldRequired } from "../components/commons/TextFieldRequired.jsx"
import { useSecurity } from "../hooks/useSecurity"

export function CrearPerfilEmpresarial() {
    const { nuevoConPerfilEmpresarial, getCuestionarioActual } = useCuestionario()
    const { getData } = useCrearPerfilEmpresarial()
    const { getMunicipios } = useMunicipios()
    const { user } = useUser()
    const { isValidDNI, isValidCIF } = useTools()
    useSecurity();


    //TODO PASAR A CONTEXT y asi solo hay que pasarlo al componente hijo el control y setValue
    const {
        //Maneja los campos del form y sus estados
        control,
        //Maneja la presentacion del formulario
        handleSubmit,
        setValue,
        watch,
        clearErrors 
    } = useForm();

    const [areFieldsDisabled, setAreFieldsDisabled] = useState(false);
    const selectedComunidad = watch("comunidadAutonoma");
    const selectedProvincia = watch("provincia");
    const selectedCnaePrincipal = watch("cnaePrincipal");
    const selectedCnaeDivision = watch("cnaeDivisiones");
    const selectedCnaeSecundaria = watch("cnaeSecundaria");

    useEffect(() => {
        var cuestionarioActualPromise = getCuestionarioActual(user);
        cuestionarioActualPromise.then(
            (x) => {
                if (x) {
                    navigate("/Identificarse");
                }
            },
            (y) => {
                console.error("Error: " + y);
            }
        );

    }, []);

    //Dependencias de los distintos campos entre ellos (Disable y borrado de values )
    useEffect(() => {
        if (!selectedComunidad) {
            setValue("provincia", null);
            setValue("municipio", null);
        }

        if (!selectedProvincia) {
            setValue("municipio", null);
        }

        if (!selectedCnaePrincipal) {
            setValue("cnaeDivisiones", null);
            setValue("cnaeSecundaria", null);
        }

        if (!selectedCnaeSecundaria) {
            setValue("cnaeSecundariaDivisiones", null);
        }

    }, [selectedComunidad, selectedProvincia, selectedCnaePrincipal, selectedCnaeDivision, selectedCnaeSecundaria, setValue]);


//Desactiva/Activa y borra todos los campos al hacer click en el checkbox
const checkedDisableAlltextFields = (event) => {
    // Comprobar si el checkbox está marcado
    if (event.target.checked) {
        // Si está marcado, borrar todos los campos y deshabilitarlos
        setValue("nif", "");
        setValue("RazonSocialNombre", "");
        setValue("categoriaEmpresa", "");
        setValue("comunidadAutonoma", "");
        setValue("provincia", "");
        setValue("municipio", "");
        setValue("cnaePrincipal", "");
        setValue("cnaeDivisiones", "");
        setValue("cnaeSecundaria", "");
        setValue("cnaeSecundariaDivisiones", "");

        // Limpiar errores
        clearErrors(["nif", "RazonSocialNombre", "categoriaEmpresa", "comunidadAutonoma", "provincia", "municipio", "cnaePrincipal", "cnaeDivisiones", "cnaeSecundaria", "cnaeSecundariaDivisiones"]);

        // Actualizar el estado para deshabilitar los campos
        setAreFieldsDisabled(true);
    } else {
        // Si el checkbox no está marcado, habilitar los campos
        setAreFieldsDisabled(false);
    }
};


    const navigate = useNavigate()
    const { t } = useTranslation()

    const [openDialogError, setOpenDialogError] = useState(false);

    const [comunidadesAutonomasList, setComunidadesAutonomasList] = useState([])
    const [categoriasEmpresaList, setCategoriasEmpresaList] = useState([])
    const [cnaeList, setCnaeList] = useState([])
    const [cnaeDivisionesList, setCnaeDivisionesList] = useState([])
    const [cnaeSecundariaDivisionesList, setCnaeSecundariaDivisionesList] = useState([])
    const [comunidadesList, setComunidadesList] = useState([])
    const [municipiosList, setMunicipiosList] = useState([])

    const [categoriaEmpresa, setCategoriaEmpresa] = useState('')
    const [comunidadAutonoma, setComunidadAutonoma] = useState('')
    const [provincia, setProvincia] = useState('')
    const [municipio, setMunicipio] = useState('')
    const [cnaePrincipal, setCnaePrincipal] = useState('')
    const [cnaeDivisiones, setCnaeDivisiones] = useState('')
    const [cnaeSecundariaDivisiones, setCnaeSecundariaDivisiones] = useState('')
    const [cnaeSecundaria, setCnaeSecundaria] = useState('')

    const [disableCIFTextField, setDisableCIFTextField] = useState(false)
    const [razonSocialField, setRazonSocialField] = useState(false)
    const [categoriaEmpresaField, setCategoriaEmpresaField] = useState(false)
    const [comunidadAutonomiaField, setComunidadAutonomiaField] = useState(false)
    const [cnaePrincipalField, setCnaePrincipalField] = useState(false)

    const handleClose = () => {
        setOpenDialogError(false);
    }

    useEffect(() => {
        getData().then(
            (data) => {
                setComunidadesAutonomasList(data.comunidadesAutonomas)
                setCategoriasEmpresaList(data.categoriaEmpresas)
                setCnaeList(data.cnaeSectores)
            },
            (promiseError) => {
                console.error("Error: " + promiseError)
            }
        );


    }, []);

    useEffect(() => {
        if (provincia?.id_provincia) {
            getMunicipios(provincia.id_provincia).then(
                (data) => {
                    setMunicipiosList(data)
                },
                (promiseError) => {
                    console.error("Error: " + promiseError)
                }
            );
        }
    }, [provincia])

    const Guardar = (data, event) => {
        let cifValidated = false

        const {
            nif,
            RazonSocialNombre,
            categoriaEmpresa,
            cnaePrincipal,
            cnaeDivisiones,
            comunidadAutonoma,
            provincia,
            municipio,
            cnaeSecundaria,
            cnaeSecundariaDivisiones
        } = data;

        if (areFieldsDisabled) {
            nuevoConPerfilEmpresarial(
                user
            ).then(x => navigate("/Ejes")).catch(y => console.log(y))
        } else {
            if (isValidDNI(nif)) {
                cifValidated = true
            }

            if (isValidCIF(nif)) {
                cifValidated = true
            }

            if (!cifValidated) {
                setOpenDialogError(true)
                event.preventDefault()
            } else {
                nuevoConPerfilEmpresarial(
                    user,
                    nif,
                    RazonSocialNombre,
                    categoriaEmpresa,
                    cnaePrincipal,
                    cnaeDivisiones,
                    comunidadAutonoma,
                    provincia,
                    municipio,
                    cnaeSecundaria,
                    cnaeSecundariaDivisiones
                ).then(x => navigate("/Ejes")).catch(y => console.log(y))
            }
        }
    }

    const handleCategoriaEmpresa = (value) => {
        setCategoriaEmpresa(value)
    }

    //TODO Tomas Preguntar a Paco, separamos en 3 funciones de una línea para tener SOLID?
    const handleChangeComunidadAutonoma = (value) => {
        setComunidadAutonoma(value)
        setComunidadesList(value.provincias)
    }

    const handleChangeProvincia = (value) => {
        setProvincia(value)
    }

    const handleChangeMunicipio = (value) => {
        setMunicipio(value)
    }

    const handleChangeCnaePrincipal = (value) => {
        setCnaePrincipal(value)
        setCnaeDivisionesList(value.divisiones)
    }

    const handleChangeCnaeDivisiones = (value) => {
        setCnaeDivisiones(value)
    }

    const handleChangeCnaeSecundaria = (value) => {
        setCnaeSecundaria(value)
        setCnaeSecundariaDivisionesList(value.divisiones)
    }

    const handleChangeCnaeSecundariaDivisiones = (value) => {
        setCnaeSecundariaDivisiones(value)
    }

    return (
        <Container>
            <Titulo titulo={t('crearPerfilEmpresarial.titulo')} size={"2.5em"} />
            <Box className='textCard'>
                <form onSubmit={handleSubmit(Guardar)}>
                    <Stack
                        direction="column"
                        justifyContent="center"
                        alignItems="center"
                        spacing={2}
                    >
                        <Box>
                            <Typography color="primary" > {t('crearPerfilEmpresarial.disclaimer')} </Typography>
                        </Box>
                        <Box sx={{ width: '100%', display: 'flex', alignContent: 'center' }}>
                            <FormGroup>
                                <FormControlLabel control={<Checkbox />} label={t('crearPerfilEmpresarial.empresaPrueba')} onChange={checkedDisableAlltextFields} />
                            </FormGroup>
                        </Box>
                        <Stack
                            direction={{ xs: 'column', md: 'row' }}
                            justifyContent="center"
                            alignItems="center"
                            spacing={2}
                            sx={{ width: '100%' }}
                        >
                            <Box sx={{ width: '100%' }}>
                                <TextFieldRequired
                                    control={control}
                                    label={t('crearPerfilEmpresarial.cif')}
                                    name="nif"
                                    disabled={areFieldsDisabled}
                                    sx={{ width: '100%' }}
                                    required={!areFieldsDisabled}
                                />
                            </Box>
                            <Box sx={{ width: '100%' }}>
                                <TextFieldRequired
                                    control={control}
                                    label={t('crearPerfilEmpresarial.nombre')}
                                    name="RazonSocialNombre"
                                    disabled={areFieldsDisabled || razonSocialField}
                                    sx={{ width: '100%' }}
                                    required={!areFieldsDisabled}
                                />
                            </Box>
                            <Box sx={{ width: '100%' }}>
                                <AutocompleteSearchRequired
                                    control={control}
                                    name="categoriaEmpresa"
                                    dataList={categoriasEmpresaList}
                                    disabled={areFieldsDisabled || categoriaEmpresaField}
                                    optionLabel={(catEmp) => catEmp.texto}
                                    labelText={t('crearPerfilEmpresarial.categoriaEmpresa')}
                                    onChangeHanddle={handleCategoriaEmpresa}
                                    required={!areFieldsDisabled}
                                    setValue={setValue}
                                />
                            </Box>
                        </Stack>
                        <Stack
                            direction={{ xs: 'column', md: 'row' }}
                            justifyContent="left"
                            alignItems="center"
                            spacing={2}
                            sx={{ width: '100%' }}
                        >
                            <Box sx={{ width: '100%' }}>
                                <AutocompleteSearchRequired
                                    control={control}
                                    name="comunidadAutonoma"
                                    dataList={comunidadesAutonomasList}
                                    optionLabel={ca => ca.nombre_comunidad}
                                    labelText={t('crearPerfilEmpresarial.comunidadAutonoma')}
                                    onChangeHanddle={handleChangeComunidadAutonoma}
                                    disabled={areFieldsDisabled || comunidadAutonomiaField}
                                    required={!areFieldsDisabled}
                                    setValue={setValue}
                                />
                            </Box>
                            <Box sx={{ width: '100%' }}>
                                <AutocompleteSearchRequired
                                    control={control}
                                    name="provincia"
                                    dataList={comunidadesList}
                                    optionLabel={co => co.nombre_provincia}
                                    labelText={t('crearPerfilEmpresarial.provincia')}
                                    onChangeHanddle={handleChangeProvincia}
                                    disabled={areFieldsDisabled || !selectedComunidad} // Deshabilita si no se ha seleccionado una comunidad
                                    required={!areFieldsDisabled}
                                    setValue={setValue}
                                />
                            </Box>
                            <Box sx={{ width: '100%' }}>
                                <AutocompleteSearchRequired
                                    control={control}
                                    name="municipio"
                                    dataList={municipiosList}
                                    optionLabel={mu => mu.nombre_municipio}
                                    labelText={t('crearPerfilEmpresarial.municipio')}
                                    onChangeHanddle={handleChangeMunicipio}
                                    disabled={areFieldsDisabled || !selectedProvincia} // Deshabilita si no se ha seleccionado una Provincia
                                    required={!areFieldsDisabled}
                                    setValue={setValue}
                                />
                            </Box>
                        </Stack>


                        <Box sx={{ width: '100%', textAlign: 'left' }}>
                            <Typography color="primary" > {t('crearPerfilEmpresarial.principalCNAE')} </Typography>
                        </Box>
                        <Stack
                            direction={{ xs: 'column', md: 'row' }}
                            justifyContent="left"
                            alignItems="center"
                            spacing={2}
                            sx={{ width: '100%' }}
                        >
                            <Box sx={{ width: '100%' }}>
                                <AutocompleteSearchRequired
                                    control={control}
                                    name="cnaePrincipal"
                                    dataList={cnaeList}
                                    optionLabel={cnae => cnae.texto_sector}
                                    labelText={t('crearPerfilEmpresarial.cnaePrincipal')}
                                    onChangeHanddle={handleChangeCnaePrincipal}
                                    disabled={areFieldsDisabled || cnaePrincipalField}
                                    required={!areFieldsDisabled}
                                    setValue={setValue}
                                />
                            </Box>
                            <Box sx={{ width: '100%' }}>
                                <AutocompleteSearchRequired
                                    control={control}
                                    name="cnaeDivisiones"
                                    dataList={cnaeDivisionesList}
                                    optionLabel={cnaeDivisiones => cnaeDivisiones.division_texto}
                                    labelText={t('crearPerfilEmpresarial.divisiones')}
                                    onChangeHanddle={handleChangeCnaeDivisiones}
                                    disabled={areFieldsDisabled || !selectedCnaePrincipal}
                                    required={!areFieldsDisabled}
                                    setValue={setValue}
                                />
                            </Box>
                        </Stack>
                        <Box sx={{ width: '100%', textAlign: 'left' }}>
                            <Typography color="primary" > {t('crearPerfilEmpresarial.secundariaCNAE')} </Typography>
                        </Box>
                        <Stack
                            direction={{ xs: 'column', md: 'row' }}
                            justifyContent="left"
                            alignItems="center"
                            spacing={2}
                            sx={{ width: '100%' }}
                        >
                            <Box sx={{ width: '100%' }}>
                                <AutocompleteSearchRequired
                                    control={control}
                                    name="cnaeSecundaria"
                                    dataList={cnaeList}
                                    optionLabel={cnae => cnae.texto_sector}
                                    labelText={t('crearPerfilEmpresarial.cnaeSecundaria')}
                                    onChangeHanddle={handleChangeCnaeSecundaria}
                                    disabled={areFieldsDisabled || !selectedCnaePrincipal}
                                    required={false}
                                    setValue={setValue}
                                />
                            </Box>
                            <Box sx={{ width: '100%' }}>
                                <AutocompleteSearchRequired
                                    control={control}
                                    name="cnaeSecundariaDivisiones"
                                    dataList={cnaeSecundariaDivisionesList}
                                    optionLabel={cnaeDivisiones => cnaeDivisiones.division_texto}
                                    labelText={t('crearPerfilEmpresarial.divisiones')}
                                    onChangeHanddle={handleChangeCnaeSecundariaDivisiones}
                                    disabled={areFieldsDisabled || !selectedCnaeSecundaria}
                                    required={false}
                                    setValue={setValue}
                                />
                            </Box>
                        </Stack>
                        <Box>
                            <Button variant='contained' type="submit">
                                {t('crearPerfilEmpresarial.guardar')}
                            </Button>
                        </Box>

                    </Stack>
                </form>
                <ErrorMessage showDialogError={openDialogError} errorDialogTitle={t('crearPerfilEmpresarial.errorNIF')} errorType={t('crearPerfilEmpresarial.mensajeErrorNIF')} handleClose={handleClose} />
            </Box>
        </Container>
    );
}
